import { MeetingRoom } from "@mui/icons-material";
import { AppBar, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import { ReactElement, useState, MouseEvent } from "react";
import { FormattedMessage } from "react-intl";

import { FlexBox } from "~frontend/components/FlexBox";
import { ContentWrapper, PageWrapper } from "~frontend/components/Layout";
import { ExternalLink } from "~frontend/components/Link";
import {
  AvatarButton,
  MenuItemIcon,
  SiteHeader,
  Subheader,
} from "~frontend/components/TopBar";
import { palette } from "~frontend/theme";

import logo from "../../components/icons/NavyLogo.svg";
import { LoggedInUser, Tenant } from "./context";

export function DeactivatedTenant({
  user,
  tenant,
}: {
  user: LoggedInUser;
  tenant: Tenant;
}): ReactElement {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseUserMenu = () => {
    setMenuOpen(false);
  };

  return (
    <ContentWrapper>
      <AppBar elevation={0} sx={{ backgroundColor: palette.darkBlue }}>
        <Toolbar variant="dense">
          <SiteHeader>{tenant.name}</SiteHeader>
          <div>
            <AvatarButton user={user} onClick={handleOpenUserMenu} />
            <Menu
              id="user-menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                horizontal: "center",
                vertical: "bottom",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={menuOpen}
              onClick={handleCloseUserMenu}
              onClose={handleCloseUserMenu}
              MenuListProps={{
                sx: {
                  width: "300px",
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",

                    "& .MuiSvgIcon-root": { color: palette.navy },
                    "> .MuiTypography-root": { pt: "2px" },
                  },
                },
              }}
            >
              <Subheader>{user.fullName}</Subheader>
              <MenuItem
                component={ExternalLink}
                dense
                href="/auth/logout"
                target="_self"
              >
                <MenuItemIcon>
                  <MeetingRoom fontSize="small" />
                </MenuItemIcon>
                <Typography variant="inherit" noWrap>
                  <FormattedMessage
                    defaultMessage="Logout"
                    description="Nav link to log out of the app"
                  />
                </Typography>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <PageWrapper>
        <FlexBox
          sx={{ height: "100%", color: palette.darkGray }}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={logo}
            alt="Scale to Win Logo"
            style={{ width: "140px", marginBottom: "24px" }}
          />
          <Typography variant="h1Bold">
            <FormattedMessage
              defaultMessage="Your Scale to Win Text account has been deactivated."
              description="Message for when the tenant has been deactivated"
            />
          </Typography>
          <Typography variant="h2">
            <FormattedMessage
              defaultMessage="If you'd like to start texting again, please fill out the {getStartedFormLink}."
              description="Subtitle for deactivated tenant page"
              values={{
                getStartedFormLink: (
                  <ExternalLink href="https://www.scaletowin.com/get-started">
                    <FormattedMessage
                      defaultMessage="Get Started form"
                      description="Get started form link text"
                    />
                  </ExternalLink>
                ),
              }}
            />
          </Typography>
        </FlexBox>
      </PageWrapper>
    </ContentWrapper>
  );
}
